export default __webpack_public_path__ + "static/media/message.a416443e.mp3";